/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: any; output: any; }
  /** The built-in `Decimal` scalar type. */
  Decimal: { input: any; output: any; }
  JSON: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION'
}

/** The scope of a cache hint. */
export enum CacheControlScope {
  /** The value to cache is specific to a single user. */
  Private = 'PRIVATE',
  /** The value to cache is not tied to a single user. */
  Public = 'PUBLIC'
}

export type Co2MaterialLibrary = {
  __typename?: 'Co2MaterialLibrary';
  co2MaterialLibraryId: Scalars['UUID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type Co2MaterialType = {
  __typename?: 'Co2MaterialType';
  a1A2A3?: Maybe<Scalars['Decimal']['output']>;
  a4?: Maybe<Scalars['Decimal']['output']>;
  a5?: Maybe<Scalars['Decimal']['output']>;
  b1?: Maybe<Scalars['Decimal']['output']>;
  b2?: Maybe<Scalars['Decimal']['output']>;
  b3?: Maybe<Scalars['Decimal']['output']>;
  b4?: Maybe<Scalars['Decimal']['output']>;
  b5?: Maybe<Scalars['Decimal']['output']>;
  b6?: Maybe<Scalars['Decimal']['output']>;
  b7?: Maybe<Scalars['Decimal']['output']>;
  biogenic?: Maybe<Scalars['Decimal']['output']>;
  c1?: Maybe<Scalars['Decimal']['output']>;
  c2?: Maybe<Scalars['Decimal']['output']>;
  c3?: Maybe<Scalars['Decimal']['output']>;
  c4?: Maybe<Scalars['Decimal']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  co2MaterialCategoryId?: Maybe<Scalars['UUID']['output']>;
  co2MaterialLibrary: Co2MaterialLibrary;
  co2MaterialLibraryId?: Maybe<Scalars['UUID']['output']>;
  co2MaterialTypeId?: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['UUID']['output']>;
  d?: Maybe<Scalars['Decimal']['output']>;
  density?: Maybe<Scalars['Decimal']['output']>;
  densityType?: Maybe<DensityType>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  massPerUnit?: Maybe<Scalars['Decimal']['output']>;
  modifiedAt: Scalars['DateTime']['output'];
  modifiedBy?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceData?: Maybe<Scalars['JSON']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  unitQuantity?: Maybe<Scalars['Decimal']['output']>;
};

/** A connection to a list of items. */
export type Co2MaterialTypeConnection = {
  __typename?: 'Co2MaterialTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Co2MaterialTypeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Co2MaterialType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type Co2MaterialTypeEdge = {
  __typename?: 'Co2MaterialTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Co2MaterialType;
};

export enum DensityType {
  Area = 'AREA',
  Volume = 'VOLUME'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  co2MaterialType?: Maybe<Co2MaterialTypeConnection>;
};


export type QueryCo2MaterialTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  co2MaterialLibrary?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};
